module.exports = "/_next/static/images/apple-icon-120x120-317cc77e5c3635c5b7eb3185e6ee1c67.png";